import React, { useEffect } from "react";
import "./navBar.scss";
import SLBLogo from "../../images/slb-logo.png";
import { ReactComponent as AssetListIcon } from "../../images/asset-icon.svg";
import { ReactComponent as UserListIcon } from "../../images/user-icon.svg";
import { ReactComponent as CustomerListIcon } from "../../images/customer-icon.svg";
import { Link, useLocation } from "react-router-dom";
import Tooltip from "../../common/tooltip/tooltip.tsx";
import RouteConstant from "../../constants/routes.ts";
import { ReactComponent as CollapseIcon } from "../../images/log-out-02.svg";
import AuthService from "../../services/authentication/auth.service.ts";
import { useSettingURL } from "../../hooks/useSettingsURL.ts";
import { getAllyConnectURL } from "../../utilities/baseUrlutility.tsx";
import useConfig from "../../hooks/useConfig.ts";

const NavigationBar: React.FC = () => {
  const { loginURL, error } = useSettingURL();
  const location = useLocation();
  const { appPath } = useConfig();

  useEffect(() => {

    const timerId = setInterval(() => {
      console.log("Refresh token called");
      if (!AuthService.refreshTokenFromServer(appPath, loginURL)) {
        AuthService.logout(appPath, loginURL);

        const host =
          process.env.REACT_APP_DEVELOPMENT_WEB_APP_BASE_URL ||
          window.location.host;

        if (loginURL) {
          const allyConnectURL = getAllyConnectURL(loginURL);
          const isOnboardingApp = window.location.pathname.includes("allyonboarding");
          console.log('NavBar: session expired instance, ' + isOnboardingApp);
          const redirectURL = isOnboardingApp ? `${loginURL}/Account/Login?app=${appPath}/login`:  `${allyConnectURL}/Account/LogOut?app=${host}${appPath}/login`;
          window.location.assign(redirectURL);
        }
      }
    }, 900000);
    return () => {
      clearInterval(timerId);
    };
  }, [loginURL]);

  const handleLogoutClick = () => {
    AuthService.logout(appPath, loginURL);
  };

  if (error) {
    console.error("Error fetching Login URL:", error);
    return null;
  }

  return (
    <div className="navigation-bar-container">
      <div className="navigation-bar-top-container">
        <div className="navigation-bar-navigation-section-container">
          <Link to={appPath+RouteConstant.pageLayout} className="navigation-bar-logo-image-container">
            <img id='slb-logo' src={SLBLogo} alt='SLB Logo' 
              className="navigation-bar-logo-image"
            />
          </Link>
          <div className="navigation-bar-buttons-container">
            <Tooltip content="Asset List" direction="right">
              <Link
                to={appPath+RouteConstant.assetDetails}
                className={`navigation-bar-navigation-image-container ${
                  location.pathname === appPath+RouteConstant.assetDetails
                    ? "active-link"
                    : ""
                }`}
              >
                <AssetListIcon width="24" height="24" stroke="#F4FBFC" />
              </Link>
            </Tooltip>
            <Tooltip content="User List" direction="right">
              <Link
                to={appPath+RouteConstant.userDetails}
                className={`navigation-bar-navigation-image-container ${
                  location.pathname === appPath+RouteConstant.userDetails
                    ? "active-link"
                    : ""
                }`}
              >
                <UserListIcon width="24" height="24" stroke="#F4FBFC" />
              </Link>
            </Tooltip>
            <Tooltip content="Customer List" direction="right">
              <Link
                to={appPath+RouteConstant.customerDetails}
                className={`navigation-bar-navigation-image-container ${
                  location.pathname === appPath+RouteConstant.customerDetails
                    ? "active-link"
                    : ""
                }`}
              >
                <CustomerListIcon width="24" height="24" stroke="#F4FBFC" />
              </Link>
            </Tooltip>
          </div>
        </div>
        <div className="navigation-bar-slide-out-section-container">
          {AuthService.isUserLoggedIn() && (
            <Tooltip content="Logout" direction="right">
              <div
                data-testid="collapse-icon"
                className={`navigation-bar-navigation-image-container`}
                onClick={handleLogoutClick}
              >
                <CollapseIcon width="24" height="24" stroke="#F4FBFC" />
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
